/**
 * Create a `FinalizationRegistry` on browsers that support it.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
 */
export function createFinalizationRegistry<T>(
    callback: (heldValue: T) => void
): FinalizationRegistry<T> | undefined {
    if (typeof FinalizationRegistry === 'function') {
        return new FinalizationRegistry(callback);
    }

    return undefined;
}
